import React from 'react';
import SvgIcon from './SvgIcon';

const OilSpill = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M4 23.5v-21M20 2.5v21M2 2.5h20M2 23.5h20M17.5 16.5H22M2 16.5h5M18 9.5h4M2 9.5h4M19 2.5V1a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5v1.5M12 16v1.5M10 17.5v-1.876A3.37 3.37 0 018 12.5a4 4 0 118 0 3.37 3.37 0 01-2 3.123V17.5M13.25 12a.25.25 0 01.25.25M13 12.25a.25.25 0 01.25-.25M13.25 12.5a.25.25 0 01-.25-.25M13.5 12.25a.25.25 0 01-.25.25M10.75 12a.25.25 0 01.25.25M10.5 12.25a.25.25 0 01.25-.25M10.75 12.5a.25.25 0 01-.25-.25M11 12.25a.25.25 0 01-.25.25"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

OilSpill.displayName = 'OilSpillIcon';

export default OilSpill;
